import { getFullUrl } from 'hubspot-url-utils';
import I18n from 'I18n';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PortalIdParser from 'PortalIdParser';
import UILink from 'UIComponents/link/UILink';
import { jsx as _jsx } from "react/jsx-runtime";
export function UninstallableMessage({
  uninstallableReason
}) {
  if (!uninstallableReason) return null;
  switch (uninstallableReason.label) {
    case 'ALREADY_INSTALLED':
      {
        const urlBase = getFullUrl('app');
        const href = `${urlBase}/integrations-settings/${PortalIdParser.get()}/installed`;
        return /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "marketplace-ui-apps-core.uninstallableReason.installed_jsx",
          elements: {
            Link: UILink
          },
          options: {
            href,
            external: true
          }
        });
      }
    case 'MISSING_HUB_SCOPES':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-ui-apps-core.uninstallableReason.missingHubScopes"
      });
    case 'INCOMPATIBLE_INSTALLS':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-ui-apps-core.uninstallableReason.incompatibleInstalls",
          options: {
            count: uninstallableReason.incompatibleInstalls.length,
            installs: I18n.formatList(uninstallableReason.incompatibleInstalls)
          }
        });
      }
    default:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-ui-apps-core.uninstallableReason.missingHubUserInstallable"
      });
  }
}